import React, { useState } from "react";
import {
    HStack,
    Box,
    Avatar,
    List,
    ListItem,
    useToast,
    IconButton,
    Flex
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { IconStar } from "@/assets/Icons";
import { like, unlike } from "@lib/datahandlers/person";
import { t } from '@lang/i18n';


const OfferItem = (props) => {
    const { id, user: {picture, company: {name}}, fonctions, experiences, address, contracts, date, liked } = props.data;

    const [favorite, setFavorite] = useState(liked);
    const toast = useToast();

    const favoriteClick = async () => {
        let fav = favorite;
        setFavorite(!fav);
        const success = await (fav? unlike(id) : like(id));
        if(!success) {
            setFavorite(fav);
            toast({
                title: "",
                description: t('global.general_error'),
                status: "warning",
                variant: 'subtle',
                duration: 3000,
            })
        }
    };
    
    return(
        <HStack 
            as={Link}
            to={`/candidate/offers/${id}`}
            bg="white"
            position="relative"
            flexDir="row" 
            justifyContent="space-between" 
            boxShadow="2px 2px 20px 0px #00000026" 
            borderRadius="4px" 
            border="solid 2px transparent"
            transitionDuration=".2s"
            cursor="pointer"
            _hover={{border: 'solid 2px var(--blue-light)'}}
            _active={{top:"2px", boxShadow: "1px 1px 10px 0px #00000026"}}
            w="385px" maxW="calc(100% - 28px)" h="125px" py=".5rem" px="1rem" m="14px"> 
            
            <Avatar name={name} w="90px" h="90px" my="auto" src={picture} />

            <List fontSize="12px" w="calc(100% - 100px)">
                <ListItem isTruncated fontWeight="bold" fontSize="16px"> {name} </ListItem>
                <ListItem isTruncated textColor="#6C6C6C" w="200px"> {address} </ListItem>
                <ListItem isTruncated fontWeight="bold" w="200px"> {fonctions.map(e=>e.name).join(', ')} </ListItem>
                <ListItem isTruncated w="200px"> Exp: {experiences.map(e=>e.name).join(', ')} </ListItem>
                <ListItem isTruncated fontWeight="bold" w="150px"> {contracts.map(e=>e.name).join(', ')} </ListItem>
            </List> 

            <Flex justifyContent="space-between" flexDir="column" position="absolute" right="16px" top="8px" bottom="8px" alignItems="flex-end">  
                <IconButton
                    justifyContent="flex-end"
                    minW="auto"
                    colorScheme="none"
                    _hover={{filter: 'brightness(1.2)'}}
                    _focus={{ boxShadow: 'none' }}
                    title={favorite ? "Retirer des favoris" : "Ajouter aux favoris"}
                    onClick={e=>{e.preventDefault(); favoriteClick()}}
                    icon={<IconStar iconType="candidate" variant={favorite ? "filled" : "outline"} />}
                />
                <Box as="span" textAlign="right" fontSize="10px"> Publiée le : {date} </Box> 
            </Flex>

        </HStack>
    )
}

export default OfferItem;
